<template>
	<div class="cortesia-page" style="position: relative;">
		<!-- <div class="cortesia-header" :style="{ 'background-image': 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8)), url(' + espectaculo.foto + ')' }"> -->
		<div class="cortesia-header">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>{{ espectaculo.tipoNombre }}</span>
					</div>
				</div>
				<div class="header-row" v-if="espectaculo.requiereInstituciones">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<img :src="espectaculo.institucionLocalEscudo" :alt="espectaculo.institucionLocalNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionLocalNombre }}</span>
							<span class="vs">vs</span>
						</div>
						<div class="header-equipo header-equipo-visitante">
							<img :src="espectaculo.institucionVisitanteEscudo" :alt="espectaculo.institucionVisitanteNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionVisitanteNombre }}</span>
						</div>
					</div>
				</div>
				<div class="header-row" v-else>
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<span>{{ espectaculo.nombre }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="cortesia-main">
			<div class="container">
				<div class="cortesia-left">
					<h1 v-if="cortesiaHabilitada">{{titulo}}</h1>
					<p v-if="cortesiaHabilitada">Completá los datos de tu cortesía</p>
					<div v-if="!cortesiaHabilitada" class="cortesia-inhabilitada">
						<span class="atencion">Atención</span>
						<span class="atencion-text">La emisión de cortesías para este espectáculo no está habilitada aún. Vuelva a este link más adelante.</span>
					</div>
					<div class="cortesias" v-if="Number(cortesia.CortesiaCntRestantes) > 0">
						<div class="cortesia" :id="'tn' + t.ticketNum" v-for="t in tickets" :key="t.ticketNum" >
							<!-- <div class="cortesia-row">
								<span class="ticket-num">Ticket #{{ t.ticketNum }}</span>
							</div> -->
							<div class="cortesia-row">
								<div class="input-group">
									<label :for="'ticket-nombre-' + t.ticketNum">Nombres</label>
									<input type="text" name="ticket-nombre" :id="'ticket-nombre-' + t.ticketNum" v-model="t.ticketNombre">
								</div>
								<div class="input-group">
									<label :for="'ticket-apellido-' + t.ticketNum">Apellidos</label>
									<input type="text" name="ticket-apellido" :id="'ticket-apellido-' + t.ticketNum" v-model="t.ticketApellido">
								</div>
							</div>
							<div class="cortesia-row">
								<div class="input-group">
									<label :for="'ticket-tipoDocumento-' + t.ticketNum">Tipo de documento</label>
									<multiselect name="tipoDocumento" :id="'ticket-tipoDocumento-' + t.ticketNum" v-model="t.ticketDocumentoTipo" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="input-group">
									<label :for="'ticket-documento-' + t.ticketNum">Documento</label>
									<input type="text" name="ticket-documento" :id="'ticket-documento-' + t.ticketNum" v-model="t.ticketDocumento" placeholder="Sin puntos ni guiones. Ej: 12345678">
								</div>
							</div>
							<!-- <div class="cortesia-row">
								<div class="input-group">
									<label :for="'ticket-telefono-' + t.ticketNum">Teléfono</label>
									<input type="text" name="ticket-telefono" :id="'ticket-telefono-' + t.ticketNum" v-model="t.ticketTelefono" @keypress="soloNumeros">
								</div>
								<div class="input-group">
									<span class="small-text">Por disposición del MSP, es obligatorio ingresar el número de teléfono del espectador</span>
								</div>
							</div> -->
							<div class="cortesia-row row-complemento">
								<div class="input-group" v-for="(complemento, index) in datosComplementarios" :key="complemento.ComplementoId">
									<label :for="complemento.ComplementoId">{{ complemento.ComplementoNombre }}</label>
									<input :name="complemento.ComplementoId" :id="complemento.ComplementoId" type="text" v-model="t.datosComplementarios[index].Valor" v-if="complemento.ComplementoTipo !== 'O'">
									<multiselect v-else :name="complemento.ComplementoId" :id="complemento.ComplementoId" v-model="t.datosComplementarios[index].Valor" :options="datosComplementarios[index].Opciones" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontraron resultados.</span>
										<span slot="noOptions">No se encontraron resultados.</span>
									</multiselect>
								</div>
							</div>
							<div class="cortesia-row">
								<div class="cortesia-ubicacion">
									<div class="cortesia-ubicacion-item">
										<span class="cortesia-ubicacion-title">Tribuna</span>
										<span class="cortesia-ubicacion-valor">{{ t.ticketTribuna }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="t.ticketSector.toUpperCase() !== 'ABDÓN PORTE'">
										<span class="cortesia-ubicacion-title">Sector</span>
										<span class="cortesia-ubicacion-valor">{{ t.ticketSector }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="t.ticketUbicacion !== null">
										<span class="cortesia-ubicacion-title">Fila</span>
										<span class="cortesia-ubicacion-valor">{{ t.ticketUbicacion.filaNombre }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="t.ticketUbicacion !== null">
										<span class="cortesia-ubicacion-title">Asiento</span>
										<span class="cortesia-ubicacion-valor">{{ t.ticketUbicacion.asientoNombre }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="cortesias-canjear" v-if="Number(cortesia.CortesiaCntRestantes) > 0">
						<button class="btn" @click="canjearCortesias">Canjear Cortesías</button>
					</div>
					<div class="cortesias cortesias-emitidas" v-if="Number(cortesia.CortesiaCntIngresadas) > 0">
						<span class="cortesias-emitidas-title">Cortesías ya emitidas</span>
						<div class="cortesia" v-for="c in ticketsEmitidos" :key="c.TicketId">
							<!-- <span>{{ c.PersonaNombre }} {{ c.PersonaApellido }}</span> -->
							<div class="cortesia-row">
								<div class="input-group">
									<label>Nombres</label>
									<span>{{ c.PersonaNombre }}</span>
								</div>
								<div class="input-group">
									<label>Apellidos</label>
									<span>{{ c.PersonaApellido }}</span>
								</div>
								<a class="descargar-ticket" :href="c.TicketURLS3" target="_blank" v-if="c.TicketGeneradoEnS3">
									<download-icon></download-icon>Descargar
								</a>
								<div class="generando-ticket" v-else>
									<loader-icon></loader-icon>
									<span>Generando ticket.</span>
								</div>
							</div>
							<!-- <div class="cortesia-row">
								<div class="input-group">
									<label>Teléfono</label>
									<span>{{ c.PersonaTelefono }}</span>
								</div>
							</div> -->
							<div class="cortesia-row">
								<div class="input-group">
									<label>Tipo de documento</label>
									<span>{{ c.PersonaDocumentoTipoNombre }}</span>
								</div>
								<div class="input-group">
									<label>Documento</label>
									<span>{{ c.PersonaDocumento }}</span>
								</div>
							</div>
							<div class="cortesia-row">
								<div class="cortesia-ubicacion">
									<div class="cortesia-ubicacion-item">
										<span class="cortesia-ubicacion-title">Tribuna</span>
										<span class="cortesia-ubicacion-valor">{{ c.TribunaNombre }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="c.SectorDescripcion.toUpperCase() !== 'ABDÓN PORTE'">
										<span class="cortesia-ubicacion-title">Sector</span>
										<span class="cortesia-ubicacion-valor">{{ c.SectorDescripcion.replace('Sector ', '') }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="c.FilaId !== null && c.FilaId !== '0' && c.FilaId !== 0">
										<span class="cortesia-ubicacion-title">Fila</span>
										<span class="cortesia-ubicacion-valor">{{ c.FilaNombre.replace('Fila ', '') }}</span>
									</div>
									<div class="cortesia-ubicacion-item" v-if="c.AsientoId !== null && c.AsientoId !== '0' && c.AsientoId !== 0">
										<span class="cortesia-ubicacion-title">Asiento</span>
										<span class="cortesia-ubicacion-valor">{{ c.AsientoNombre.replace('Asiento ', '') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="cortesia-right">
					<p>Información del espectáculo</p>
					<div class="cortesia-right-content">
						<div class="competencia" v-if="espectaculo.mostrarCompetencia">
							<div class="competencia-info">
								<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
								<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
							</div>
							<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
						</div>
						<div class="fecha" v-if="espectaculo.mostrarFecha">
							<span class="fecha-title">Fecha</span>
							<div class="fecha-content">
								<div class="fecha-texto">
									<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
									<p>{{ espectaculo.fechaEscrita }}</p>
								</div>
								<div class="fecha-hora">
									{{ espectaculo.hora }}
								</div>
							</div>
						</div>
						<div class="lugar" v-if="espectaculo.mostrarEscenario">
							<span class="lugar-title">Lugar</span>
							<div class="lugar-content">
								<div class="lugar-content-left">
									<div class="lugar-info">
										<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
										<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
									</div>
									<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre">
								</div>
								<div class="ver-mapa" content="Ver ubicación" v-tippy="{ placement : 'bottom'}" v-if="espectaculo.escenarioMapaURL">
									<a :href="espectaculo.escenarioMapaURL" target="_blank"><map-icon></map-icon></a>
								</div>
							</div>
						</div>
						<div class="descripcion">
							<span class="descripcion-title">Descripción</span>
							<!-- <span class="descripcion-content">{{ espectaculo.descripcion }}</span> -->
							<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { MapIcon, DownloadIcon, LoaderIcon } from 'vue-feather-icons'

	export default {
		data(){
			return {
				timer: null,

				titulo: 'Cortesía',
				cortesia: {
					EspectaculoId: null,
					CortesiaId: null,
					CortesiaFchIng: null,
					CortesiaUsuarioId: null,
					CortesiaSolicitanteNombre: null,
					CortesiaSolicitanteEmail: null,
					CortesiaCntSolicitadas: null,
					CortesiaCntIngresadas: null,
					CortesiaCntRestantes: null,
					CortesiaToken: null,
					CortesiaTipoId: null,
					CortesiaTribunaId: null,
					CortesiaSectorCod: null,
					CortesiaEscenarioId: null
				},
				espectaculo: {
					id: null,
					nombre: '',
					descripcion: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					fechaDiaSemanaEscrito: '',
					hora: '',
					escenarioNombre: '',
					escenarioLogo: '',
					escenarioSVG: '',
					escenarioMapaURL: '',
					escenarioDireccion: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					foto: null,
					requiereRepresentacionGrafica: true,
					mostrarCompetencia: false,
					mostrarFecha: false,
					mostrarEscenario: false
				},
				tickets: [],
				ticketsEmitidos: [],
				tipoDocumentoCI: null,
				tipoDocumentos: [],
				
				/* Datos complementarios */
				datosComplementarios: [],

				cortesiaHabilitada: false
			}
		},
		components: {
			MapIcon,
			DownloadIcon,
			LoaderIcon
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.tiposDocumento();
			await this.validarCortesia();
			this.$store.dispatch('cargando', false);
		},
		watch: {
			ticketsEmitidos(newTicketsEmitidos){
				this.ticketsEmitidos.forEach((t, index) => {
					if(t.TicketGeneradoEnS3 === false){
						this.timeoutCheckearTicket(t.TicketId, index);
					}
				});
			}
		},
		methods: {
			timeout(){
				return new Promise(resolve => setTimeout(resolve, 5000));
			},
			async timeoutCheckearTicket(ticketId, index){
				do {
					await this.timeout();
					await this.checkearTicketGenerado(ticketId);
				} while (this.ticketsEmitidos[index].TicketGeneradoEnS3 === false)
			},
			async checkearTicketGenerado(ticketId){
				try {
					let response = await axios.post('/WSTicketGeneradoEnS3', { TicketId: Number(ticketId) });
					
					if(response.data.ErrorCod === 0){
						if(response.data.isGeneradoEnS3 === true){
							let indexEmitidos = this.ticketsEmitidos.map(ticket => ticket.TicketId).indexOf(ticketId)
							this.ticketsEmitidos[indexEmitidos].TicketGeneradoEnS3 = true;
						}
					} else {
						console.log('Ocurrió un error al checkear generación del PDF')
					}
				} catch (error) {
					console.log('Ocurrió un error al checkear generacion del PDF')
				}
			},
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async tiposDocumento(){
				// Obtengo tipos de documento
				try{
					let response = await axios.post('/WSDocumentoTipoCortesiaPalco', {});
					for(var o=0; o<response.data.SDTDocumentoTipo.length; o++){
						this.tipoDocumentos.push({ valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre });

						if(Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre }
						}
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async validarCortesia(){
				// Valido cortesía
				try{
					let response = await axios.post('/WSCortesiaValidar', {	EspectaculoId: Number(this.$route.params.espectaculoId), CortesiaId: Number(this.$route.params.cortesiaId), CortesiaToken: this.$route.params.cortesiaToken }, {})

					if(response.data.ErrorCod === 0){
						this.cortesiaHabilitada = true
						this.cortesia = response.data.SDTCortesia;
						this.ticketsEmitidos = response.data.SDTTicketsCortesia;
						this.tickets = [];
						this.datosComplementarios = [];

						if(Number(response.data.SDTCortesia.CortesiaTipoId) === 6){
							this.titulo = 'Invitaciones a tribuna - Palco ' + response.data.SDTCortesia.CortesiaSolicitanteNombre
						} else {
							this.titulo = 'Cortesía'
						}

						if(Number(this.cortesia.CortesiaCntRestantes) > 0){
							for(let i = 0; i<this.cortesia.CortesiaCntRestantes; i++){
								let sector = this.cortesia.CortesiaSectorDescripcion.replace('Sector ', '')
								
								let ticket = {
									ticketNum: i + 1,
									ticketNombre: '',
									ticketApellido: '',
									ticketDocumentoTipo: this.tipoDocumentoCI,
									ticketDocumento: '',
									ticketTelefono: '',
									ticketTribuna: this.cortesia.CortesiaTribunaNombre,
									ticketSector: sector,
									ticketUbicacion: null,
									datosComplementarios: []
								}
								
								if(this.cortesia.Ubicacion.length > 0){
									for(let n=0; n<this.cortesia.Ubicacion.length; n++)	{
										if(n === i){
											let fila = this.cortesia.Ubicacion[n].CortesiaFilaNombre.replace('Fila ', '')
											let asiento = this.cortesia.Ubicacion[n].CortesiaAsientoNombre.replace('Asiento ', '')

											ticket.ticketUbicacion = { filaId: Number(this.cortesia.Ubicacion[n].CortesiaFilaId), filaNombre: fila, asientoId: Number(this.cortesia.Ubicacion[n].CortesiaAsientoId), asientoNombre: asiento }
										}
									}
								}

								this.tickets.push(ticket);
							}
						}

						let data = response.data.SDTEspectaculo;
						this.espectaculo.id = Number(data.EspectaculoId);
						this.espectaculo.nombre = data.EspectaculoNombre;
						this.espectaculo.descripcion = data.EspectaculoDescripcion;
						this.espectaculo.tipoId = Number(data.EspectaculoTipoId);
						this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculo.tipoColor = data.EspectaculoTipoColor;
						this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
						this.espectaculo.hora = data.EspectaculoHora;
						this.espectaculo.escenarioNombre = data.EscenarioNombre;
						this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
						this.espectaculo.escenarioDireccion = data.EscenarioDireccion;
						this.espectaculo.competenciaNombre = data.CompetenciaNombre;
						this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculo.requiereRepresentacionGrafica = data.EspectaculoRepresentacionGrafica;
						if (data.EspectaculoFotoURL.length > 0) {
							this.espectaculo.foto = data.EspectaculoFotoURL;
						} else {
							this.espectaculo.foto = process.env.VUE_IMG_BUCKET + 'parque-aereo.jpg';
						}
						this.espectaculo.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia;
						this.espectaculo.mostrarFecha = data.EspectaculoFrontMostrarFecha;
						this.espectaculo.mostrarEscenario = data.EspectaculoFrontMostrarEscenario;

						await this.cargoDatosComplementarios();
					} else {
						if(response.data.ErrorCod === 40){
							this.cortesiaHabilitada = false
							let data = response.data.SDTEspectaculo;
							this.espectaculo.id = Number(data.EspectaculoId);
							this.espectaculo.nombre = data.EspectaculoNombre;
							this.espectaculo.descripcion = data.EspectaculoDescripcion;
							this.espectaculo.tipoId = Number(data.EspectaculoTipoId);
							this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
							this.espectaculo.tipoColor = data.EspectaculoTipoColor;
							this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
							this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
							this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
							this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
							this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
							this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
							this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
							this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
							this.espectaculo.hora = data.EspectaculoHora;
							this.espectaculo.escenarioNombre = data.EscenarioNombre;
							this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
							this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
							this.espectaculo.escenarioDireccion = data.EscenarioDireccion;
							this.espectaculo.competenciaNombre = data.CompetenciaNombre;
							this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
							this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
							this.espectaculo.requiereRepresentacionGrafica = data.EspectaculoRepresentacionGrafica;
							if (data.EspectaculoFotoURL.length > 0) {
								this.espectaculo.foto = data.EspectaculoFotoURL;
							} else {
								this.espectaculo.foto = process.env.VUE_IMG_BUCKET + 'parque-aereo.jpg';
							}
							this.espectaculo.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia;
							this.espectaculo.mostrarFecha = data.EspectaculoFrontMostrarFecha;
							this.espectaculo.mostrarEscenario = data.EspectaculoFrontMostrarEscenario;
						} else {
							this.$router.push({ name: 'error' });
						}
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async canjearCortesias(){
				let colTicketCortesias = []
				let TicketComplemento;
				let SDTComplementosValores = [];
				let SDTComplementosValoresJSON = '';

				let todosVacios = true
				for(let v=0; v<this.tickets.length; v++){
					if(this.tickets[v].ticketApellido || this.tickets[v].ticketNombre || this.tickets[v].ticketDocumento){
						todosVacios = false
						break;
					}
				}

				let hayRepetidos = false

				if(todosVacios === true){
					this.$store.dispatch('mostrarError', 'Debes ingresar al menos una cortesia')
				} else {
					let hayError = false;
					for(let m=0; m<this.tickets.length; m++){
						if(this.tickets[m].ticketApellido || this.tickets[m].ticketNombre || this.tickets[m].ticketDocumento){
							if(this.tickets[m].ticketApellido && this.tickets[m].ticketNombre && this.tickets[m].ticketDocumento){
								for(let k=0; k<this.tickets.length; k++){
									if(k !== m){
										if(this.tickets[m].ticketDocumento && this.tickets[m].ticketDocumento === this.tickets[k].ticketDocumento){
											hayRepetidos = true;
											break;
										}
									}
								}

								if(hayRepetidos === true){
									hayError = true
									this.$store.dispatch('mostrarError', 'Hay documentos repetidos')
									break;
								} else {
									// if(this.tickets[m].ticketTelefono.length < 8 || this.tickets[m].ticketTelefono.length > 20){
									// 	hayError = true
									// 	this.$store.dispatch('mostrarError', 'Ticket #' + this.tickets[m].ticketNum + ' - Teléfono incorrecto')
									// 	break;
									// } else {
										// Validación datos complementarios
										for(let k=0; k<this.datosComplementarios.length; k++){
											let isDatoObligatorio = this.datosComplementarios[k].EspectaculoComplementoObligatorio;

											if(isDatoObligatorio){
												if(!this.tickets[m].datosComplementarios[k].Valor && this.datosComplementarios[k].ComplementoTipo === 'O'){
													hayError = true
													this.$store.dispatch('mostrarError', 'Ticket #' + this.tickets[m].ticketNum + ': debes seleccionar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase())
													break;
												}

												if(this.datosComplementarios[k].ComplementoTipo !== 'O'){
													if(!this.tickets[m].datosComplementarios[k].Valor){
														hayError = true
														this.$store.dispatch('mostrarError', 'Ticket #' + this.tickets[m].ticketNum + ': debes ingresar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase())
														break;
													} else {
														if(this.tickets[m].datosComplementarios[k].Valor.trim() === ''){
															hayError = true
															this.$store.dispatch('mostrarError', 'Ticket #' + this.tickets[m].ticketNum + ': debes ingresar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase())
															break;
														}
													}
												}
											}
										}

										if(hayError === true){
											break;
										}

										let fil = null;
										let asi = null;

										if(this.tickets[m].ticketUbicacion !== null){
											fil = Number(this.tickets[m].ticketUbicacion.filaId);
											asi = Number(this.tickets[m].ticketUbicacion.asientoId);
										}

										let itemTicketCortesia = {
											TicketId: this.tickets[m].ticketNum,
											TicketTipo: '',
											TicketMonto: 0,
											TribunaId: Number(this.cortesia.CortesiaTribunaId),
											SectorCod: this.cortesia.CortesiaSectorCod,
											FilaId: fil,
											AsientoId: asi,
											PersonaNombre: this.tickets[m].ticketNombre.trim(),
											PersonaApellido: this.tickets[m].ticketApellido.trim(),
											PersonaDocumentoTipoId: Number(this.tickets[m].ticketDocumentoTipo.valor),
											PersonaDocumentoTipoNombre: '',
											PersonaDocumentoTipoAbreviacion: '',
											PersonaDocumento: this.tickets[m].ticketDocumento,
											// PersonaTelefono: this.tickets[m].ticketTelefono,
											PersonaTelefono: '',
											TransaccionId: 0
										}

										colTicketCortesias.push(itemTicketCortesia);

										for(let s=0; s<this.tickets[m].datosComplementarios.length; s++){
											let value = null;

											if(this.datosComplementarios[s].ComplementoTipo === 'O'){
												if(this.tickets[m].datosComplementarios[s].Valor){
													value = this.tickets[m].datosComplementarios[s].Valor.valor;
												}
											} else {
												if(this.tickets[m].datosComplementarios[s].Valor && this.tickets[m].datosComplementarios[s].Valor.trim() !== ''){
													value = this.tickets[m].datosComplementarios[s].Valor;
												}
											}

											if(value){
												TicketComplemento = {
													Index: Number(this.tickets[m].ticketNum),
													ComplementoId: this.tickets[m].datosComplementarios[s].ComplementoId,
													ComplementoRegistroValor: value
												}

												SDTComplementosValores.push(TicketComplemento);
											}
										}
									// }
								}
							} else {
								hayError = true
								this.$store.dispatch('mostrarError', 'Debes ingresar todos los datos para el ticket #' + this.tickets[m].ticketNum)
							}
						}
					}

					SDTComplementosValoresJSON = JSON.stringify(SDTComplementosValores);

					if(hayError === false){
						this.$store.dispatch('cargando', true);

						// Canjeo cortesías
						try{
							let response = await axios.post('/WSCortesiaTicket', { EspectaculoId: Number(this.$route.params.espectaculoId), CortesiaId: Number(this.$route.params.cortesiaId), CortesiaToken: this.$route.params.cortesiaToken, SDTTicketCortesias: colTicketCortesias, SDTComplementosValoresJSON: SDTComplementosValoresJSON })

							if(response.data.ErrorCod === 0){
								this.$store.dispatch('mostrarSuccess', 'Cortesías emitidas correctamente')
								await this.validarCortesia();
								this.$store.dispatch('cargando', false);
							} else {
								if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 20 || response.data.ErrorCod === 30 || response.data.ErrorCod === 40 || response.data.ErrorCod === 50 || response.data.ErrorCod === 60 || response.data.ErrorCod === 61 || response.data.ErrorCod === 80){
									this.$store.dispatch('mostrarError', 'Ocurrió un error')
									this.$router.push({ name: 'error' });
								} else {
									this.$store.dispatch('mostrarError', response.data.ErrorDsc)
									this.$store.dispatch('cargando', false);
								}
							}
						} catch(error){
							this.$store.dispatch('mostrarError', 'Ocurrió un error')
							this.$store.dispatch('cargando', false);
						}
					}
				}
			},
			async cargoDatosComplementarios(){
				try {
					let response = await axios.post('/WSEspectaculoDatosComplCortesia', { EspectaculoId : Number(this.$route.params.espectaculoId) });
					
					if(response.data.ErrorCod === 0){
						response.data.SDTDatosComplementarios.map((d)=>{
							let opciones = [];
							let opcion = {}

							if(d.Opciones.length){
								for(let i = 0; i<d.Opciones.length; i++){
									opcion = {
										valor: d.Opciones[i].ComplementoOpcionId,
										descripcion: d.Opciones[i].ComplementoOpcionValor
									}

									opciones.push(opcion)
								}
							}
							
							let datoComplementario = {
								ComplementoId: d.ComplementoId,
								ComplementoNombre: d.ComplementoNombre,
								ComplementoTipo: d.ComplementoTipo,
								Opciones: opciones,
								EspectaculoComplementoObligatorio: d.EspectaculoComplementoObligatorio
							}

							this.datosComplementarios.push(datoComplementario);

							for(let j = 0; j<this.tickets.length; j++){
								this.tickets[j].datosComplementarios.push({ ComplementoId: d.ComplementoId, Valor: null });
							}
						});
					}
				} catch (error) {
					console.log('Error al cargar datos complementarios')
				}
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
	// Multiselects
	.multiselect {
		min-height: 44px;
		width: 100%;
		cursor: pointer;
		transition: all 0.2s;

		&:hover .multiselect__tags {
			transition: all 0.2s;
			border-color: var(--color-blue);
		}
	}

	.multiselect__input,
	.multiselect__single {
		margin: 0;
		font-size: 16px;
		line-height: 25px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-left: 0;
	}

	.multiselect__tags {
		border-radius: 0px;
		font-size: 16px;
		line-height: 25px;
		border: none;
		border-bottom: 1px solid var(--color-grey-light);
		display: block;
		width: 100%;
		height: 100%;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-top: 8px;
		padding-bottom: 10px;
		padding-left: 0px;
		padding-right: 40px;
		outline: none;
		background-color: var(--color-white);
	}

	.multiselect__option--highlight {
		background-color: var(--color-grey-lighter);
		color: var(--color-black);
	}

	.multiselect__option--selected.multiselect__option--highlight {
		background-color: var(--color-red);
		// border-left: 2px solid var(--color-blue-dark);
		color: var(--color-white);
	}

	.multiselect__option {
		font-size: 13px;
		line-height: 13px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
	}

	.multiselect__option--selected {
		background-color: var(--color-blue);
		color: var(--color-white);
		font-size: 13px;
		line-height: 13px;
	}

	.multiselect__option--highlight:after {
		background: transparent;
		color: #999;
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__option--selected.multiselect__option--highlight:after,
	.multiselect__option--selected:after {
		background: transparent;
		color: var(--color-white);
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__tag {
		margin-bottom: 3px !important;
		margin-right: 8px !important;
		background: var(--color-blue) !important;
	}

	.multiselect__tag-icon:after {
		color: var(--color-white) !important;
	}

	.multiselect__tag-icon:focus,
	.multiselect__tag-icon:hover {
		background: none !important;
	}

	.multiselect__placeholder {
		padding-top: 0px;
		margin-bottom: 0px;
	}

	@media screen and(max-width: 590px){
		.multiselect__input, .multiselect__single{
			font-size: 14px !important;
		}

		.multiselect__tags{
			padding-top: 10px;
			padding-bottom: 6px;
			padding-right: 30px;
		}
	}
</style>

<style lang="scss" scoped>
	.cortesia-page{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.cortesia-header{
			padding-top: 76px;
			width: 100%;
			position: relative;
			height: 310px;
			background: url('../../assets/sports-player-background.jpg');
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			@include flex(column, flex-start, center);

			.container{
				height: 100%;
				margin: 0;
				width: 100%;
				@include flex(column, flex-end, center);

				max-width: 1166px;
				padding: 0px 16px;
				z-index: 1;
				padding-bottom: 10px;
				@include flex(column, flex-end, flex-start);
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: #fff;
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							line-height: 1.1em;
							color: var(--color-white);
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
						}

						&.header-equipo-local{

							span{
								font-size: 32px;

								&.vs{
									font-family: var(--font-family-poppins);
									line-height: 1em;
									color: var(--color-blue-light);
									font-size: 24px;
									margin-left: 10px;
									margin-top: 6px;
									font-weight: var(--font-weight-bold);
								}
							}

							.header-escudo{
								height: 39px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{
							margin-top: 5px;
							
							span{
								font-size: 30px;
							}

							.header-escudo{
								height: 34px;
								width: auto;
								margin-right: 10px;
								margin-left: 3px;
							}
						}
					}
				}
			}
		}

		.cortesia-main{
			width: 100%;
			position: relative;
			margin: 64px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.cortesia-right{
					top: 102px;
					position: sticky;
					margin-top: 41px;
					width: calc(33.33% - 16px);

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
						margin-bottom: 18px;
					}

					.cortesia-right-content{
						border-radius: 8px;
						border: 1px solid #d3d3dc;
						@include flex(column, flex-start, flex-start);

						.competencia{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(row, space-between, center);

							.competencia-info{
								@include flex(column, center, flex-start);

								span.competencia-nombre{
									margin: 0;
									font-size: 13px;
									line-height: 20px;
									margin-bottom: 0px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								span.competencia-instancia{
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 15px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}

							img{
								height: 32px;
								width: auto;
								margin-left: 15px;
							}
						}

						.fecha{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.fecha-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.fecha-content{
								width: 100%;
								@include flex(row, space-between, center);

								.fecha-texto{
									@include flex(column, center, flex-start);

									p{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 20px;
										margin: 0;
									}
								}

								.fecha-hora{
									height: 100%;
									margin-left: 14px;
									border-left: 1px solid #d3d3dc;
									padding: 10px 0 10px 14px;
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 21px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}
						}

						.lugar{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.lugar-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.lugar-content{
								@include flex(row, space-between, center);
								width: 100%;

								.lugar-content-left{
									@include flex(row, flex-start, center);

									.lugar-info{
										padding-right: 12px;
										// border-right: 1px solid #d3d3dc;
										@include flex(column, center, flex-start);

										span.lugar-escenario{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 15px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 20px;
										}

										span.lugar-direccion{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 13px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 18px;
										}
									}

									img{
										width: 28px;
										height: auto;
										margin-left: 12px;
									}
								}

								.ver-mapa{
									@include flex(column, center, center);
									margin-left: 12px;

									a{
										background-color: transparent;
										border: 1px solid var(--color-blue-darker);
										padding: 6px;
										text-decoration: none;
										@include flex(row, center, center);
										transition: all .2s;
										border-radius: 99px;

										svg{
											width: 15px;
											height: auto;
											transition: all .2s;
											color: var(--color-blue-darker);
										}

										&:hover{
											background-color: var(--color-blue-darker);

											svg{
												color: var(--color-white);
											}
										}
									}
								}
							}
						}

						.descripcion{
							border-radius: 0px;
							border: none;
							padding: 20px;
							width: 100%;
							@include flex(column, flex-start, flex-start);
							
							.descripcion-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.descripcion-content{
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}
					}
				}

				.cortesia-left{
					width: calc(66.66% - 16px);
					background-color: var(--color-white);
					padding: 0px;

					h1{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}

					.cortesia-inhabilitada{
						padding: 20px;
						box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
						@include flex(column, flex-start, flex-start);

						.atencion{
							color: var(--color-red);
							font-size: 11px;
							line-height: 1em;
							font-family: var(--font-family-poppins);
							font-weight: bold;
							text-transform: uppercase;
							margin-bottom: 6px;
						}

						.atencion-text{
							font-size: 16px;
							line-height: 25px;
							width: 100%;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-darker);
							font-family: var(--font-family-poppins);
							// text-transform: uppercase;
							padding-top: 2px;
						}
					}

					.cortesias{
						width: 100%;
						margin-top: 20px;
						display: grid;
						grid-template-columns: repeat(1, 1fr);
						// grid-auto-rows: 1fr;
						// grid-column-gap: 20px;
						grid-row-gap: 25px;

						.cortesia{
							border-radius: 0px;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							width: 100%;
							padding: 20px;
							padding-left: 70px;
							position: relative;
							background-color: var(--color-white);
							@include flex(column, flex-start, flex-start);
							transition: all .2s;

							&:hover{
								&:after{
									background-color: var(--color-blue-light);
									color: var(--color-blue-darker);
								}

								&:before{
									background-color: var(--color-blue-light);
									color: var(--color-blue-darker);
								}
							}

							&:after{
								content: 'Cortesía';
								position: absolute;
								top: 0px;
								left: 0px;
								width: 50px;
								height: calc(100% - 50px);
								@include flex(row, center, center);
								color: var(--color-white);

								writing-mode:vertical-lr;

								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								-webkit-letter-spacing: 2px;
								-moz-letter-spacing: 2px;
								-ms-letter-spacing: 2px;
								letter-spacing: 2px;
								font-size: 13px;
								background-color: var(--color-blue);
							}

							&:before{
								content: '';
								position: absolute;
								bottom: 0px;
								left: 0px;
								width: 50px;
								height: 50px;
								color: var(--color-white);
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								font-family: var(--font-family-poppins);
								@include flex(row, center, center);
								background-color: var(--color-red);
							}

							&#tn1:before{
								content: '#1';
							}

							&#tn2:before{
								content: '#2';
							}

							&#tn3:before{
								content: '#3';
							}

							&#tn4:before{
								content: '#4';
							}

							&#tn5:before{
								content: '#5';
							}

							&#tn6:before{
								content: '#6';
							}

							&#tn7:before{
								content: '#7';
							}

							&#tn8:before{
								content: '#8';
							}

							&#tn9:before{
								content: '#9';
							}

							&#tn10:before{
								content: '#10';
							}

							&#tn11:before{
								content: '#11';
							}

							&#tn12:before{
								content: '#12';
							}

							&#tn13:before{
								content: '#13';
							}

							&#tn14:before{
								content: '#14';
							}

							&#tn15:before{
								content: '#15';
							}

							&#tn16:before{
								content: '#16';
							}

							&#tn17:before{
								content: '#17';
							}

							&#tn18:before{
								content: '#18';
							}

							&#tn19:before{
								content: '#19';
							}

							&#tn20:before{
								content: '#20';
							}

							&#tn21:before{
								content: '#21';
							}

							&#tn22:before{
								content: '#22';
							}

							&#tn23:before{
								content: '#23';
							}

							&#tn24:before{
								content: '#24';
							}

							&#tn25:before{
								content: '#25';
							}

							&#tn26:before{
								content: '#26';
							}

							&#tn27:before{
								content: '#27';
							}

							&#tn28:before{
								content: '#28';
							}

							&#tn29:before{
								content: '#29';
							}

							&#tn30:before{
								content: '#30';
							}

							&#tn31:before{content: '#31' ;}
							&#tn32:before{content: '#32';}
							&#tn33:before{content: '#33';}
							&#tn34:before{content: '#34';}
							&#tn35:before{content: '#35';}
							&#tn36:before{content: '#36';}
							&#tn37:before{content: '#37';}
							&#tn38:before{content: '#38';}
							&#tn39:before{content: '#39';}
							&#tn40:before{content: '#40';}
							&#tn41:before{content: '#41';}
							&#tn42:before{content: '#42';}
							&#tn43:before{content: '#43';}
							&#tn44:before{content: '#44';}
							&#tn45:before{content: '#45';}
							&#tn46:before{content: '#46';}
							&#tn47:before{content: '#47';}
							&#tn48:before{content: '#48';}
							&#tn49:before{content: '#49';}
							&#tn50:before{content: '#50';}
							&#tn51:before{content: '#51';}
							&#tn52:before{content: '#52';}
							&#tn53:before{content: '#53';}
							&#tn54:before{content: '#54';}
							&#tn55:before{content: '#55';}
							&#tn56:before{content: '#56';}
							&#tn57:before{content: '#57';}
							&#tn58:before{content: '#58';}
							&#tn59:before{content: '#59';}
							&#tn60:before{content: '#60';}
							&#tn61:before{content: '#61';}
							&#tn62:before{content: '#62';}
							&#tn63:before{content: '#63';}
							&#tn64:before{content: '#64';}
							&#tn65:before{content: '#65';}
							&#tn66:before{content: '#66';}
							&#tn67:before{content: '#67';}
							&#tn68:before{content: '#68';}
							&#tn69:before{content: '#69';}
							&#tn70:before{content: '#70';}
							&#tn71:before{content: '#71';}
							&#tn72:before{content: '#72';}
							&#tn73:before{content: '#73';}
							&#tn74:before{content: '#74';}
							&#tn75:before{content: '#75';}
							&#tn76:before{content: '#76';}
							&#tn77:before{content: '#77';}
							&#tn78:before{content: '#78';}
							&#tn79:before{content: '#79';}
							&#tn80:before{content: '#80';}
							&#tn81:before{content: '#81';}
							&#tn82:before{content: '#82';}
							&#tn83:before{content: '#83';}
							&#tn84:before{content: '#84';}
							&#tn85:before{content: '#85';}
							&#tn86:before{content: '#86';}
							&#tn87:before{content: '#87';}
							&#tn88:before{content: '#88';}
							&#tn89:before{content: '#89';}
							&#tn90:before{content: '#90';}
							&#tn91:before{content: '#91';}
							&#tn92:before{content: '#92';}
							&#tn93:before{content: '#93';}
							&#tn94:before{content: '#94';}
							&#tn95:before{content: '#95';}
							&#tn96:before{content: '#96';}
							&#tn97:before{content: '#97';}
							&#tn98:before{content: '#98';}
							&#tn99:before{content: '#99';}
							&#tn100:before{content: '#100';}

							.cortesia-row{
								width: 100%;
								@include flex(row, space-between, center);

								.input-group{
									width: 50%;
									padding: 0px 8px 8px 8px;
									margin: 0;
									@include flex(column, center, flex-start);
									position: relative;

									&:first-child{
										padding-left: 0px;
									}

									&:last-child{
										padding-right: 0px;
									}

									label{
										font-size: 16px;
										font-weight: var(--font-weight-regular);
										color: var(--color-grey);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 19px;
										font-family: var(--font-family-fira);
									}

									input{
										font-size: 16px;
										line-height: 25px;
										padding-top: 8px;
										border-bottom: 1px solid var(--color-grey-light);
										display: block;
										width: 100%;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 8px;
										padding-bottom: 10px;

										&:focus{
											border-color: var(--color-blue);
										}
									}

									.small-text{
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-grey);
										font-family: var(--font-family-fira);
										font-size: 11px;
										line-height: 1.4em;
										padding: 0px 10px;
									}
								}

								.cortesia-ubicacion{
									margin-top: 10px;
									width: 100%;
									@include flex(row, flex-start, center);

									.cortesia-ubicacion-item{
										padding: 8px 22px 8px 12px;
										// border: 1px dashed var(--color-grey-medium);
										// background-color: #f3f3f9;
										border-right: 1px dashed var(--color-grey-medium);
										border-radius: 0px;
										@include flex(column, flex-start, flex-start);
										margin-right: 10px;

										&:last-child{
											border-right: none;
										}

										.cortesia-ubicacion-title{
											font-size: 14px;
											font-weight: var(--font-weight-regular);
											color: var(--color-grey);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 16px;
											font-family: var(--font-family-fira);
										}

										.cortesia-ubicacion-valor{
											font-weight: var(--font-weight-bold);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											color: var(--color-dark);
											font-family: var(--font-family-poppins);
											text-transform: uppercase;
										}
									}
								}

								&.row-complemento{
									flex-wrap: wrap;

									.input-group{
										width: 50%;
										padding-bottom: 15px;

										&:nth-child(2n){
											padding-right: 0px;
										}

										&:nth-child(2n + 1){
											padding-left: 0px;
										}
									}
								}
							}

							.ticket-num{
								font-weight: var(--font-weight-bold);
								font-family: var(--font-family-poppins);
								font-size: 12px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								padding: 2px 9px;
								border-radius: 22px;
								background-color: transparent;
								border: 1px solid var(--color-blue);
								color: var(--color-blue);
								letter-spacing: 1px;
								transition: all .2s;
							}
						}
					}

					.cortesias-canjear{
						position: sticky;
						bottom: 0px;
						
						button.btn{
							width: 100%;
							@include flex(row, center, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							width: 100%;
							background-color: var(--color-red);
							color: var(--color-white);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							min-height: 48px;
							padding: 0 24px;
							font-size: 16px;
							line-height: 25px;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 0;
							margin: 0;
							margin-top: 32px;

							&:hover{
								background-color: var(--color-blue-dark);
							}
						}
					}

					.cortesias-emitidas{
						margin-top: 30px;

						.cortesias-emitidas-title{
							margin: 0;
							font-size: 18px;
							line-height: 26px;
							font-family: var(--font-family-fira);
							font-weight: bold;
							color: var(--color-dark);
						}

						.cortesia{
							&:after{
								background-color: var(--color-grey-light);
								color: var(--color-blue-darker);
								height: 100%;
							}

							&:before{
								content: none;
							}

							&:hover{
								&:after{
									background-color: var(--color-grey-light);
									color: var(--color-blue-darker);
								}
							}

							.cortesia-row{
								@include flex(row, flex-start, center);

								.input-group{
									width: 40%;

									span{
										margin: 0;
										font-size: 16px;
										line-height: 25px;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-left: 0;
										padding-top: 4px;
										padding-bottom: 5px;
									}
								}

								.descargar-ticket{
									width: 20%;
									@include flex(column, center, center);
									color: var(--color-blue);
									font-size: 13px;
									cursor: pointer;
									line-height: 25px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
									text-decoration: none;
									transition: all .2s;

									svg{
										height: auto;
										width: 18px;
										margin-bottom: 4px;
									}

									&:hover{
										opacity: 0.8;
									}
								}

								.generando-ticket{
									width: 20%;
									@include flex(column, center, center);
									color: var(--color-grey);
									font-size: 12px;
									line-height: 18px;
									font-weight: var(--font-weight-regular);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									font-family: var(--font-family-fira);
									text-decoration: none;
									text-align: center;
									transition: all .2s;

									svg{
										height: auto;
										width: 24px;
										margin-bottom: 6px;
										-webkit-animation: rotating 2s linear infinite;
										-moz-animation: rotating 2s linear infinite;
										-ms-animation: rotating 2s linear infinite;
										-o-animation: rotating 2s linear infinite;
										animation: rotating 2s linear infinite;
									}
								}

								.cortesia-ubicacion{
									padding-top: 10px;
									border-top: 1px solid var(--color-grey-light);
									width: 100%;
								}
							}
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and(max-width: 910px){
		.cortesia-page{
			.cortesia-header{
				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 24px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 32px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							font-size: 18px;
							margin-left: 8px;
							margin-top: 3px;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 28px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}

			.cortesia-main{
				margin: 30px 0;
				.container{
					@include flex(column, flex-start, flex-start);

					.cortesia-left{
						width: 100%;
					}

					.cortesia-right{
						margin-top: 30px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 590px){
		.cortesia-page{
			.cortesia-main{
				.container{
					 .cortesia-left{
						  .cortesias{
							   .cortesia{
								   padding-left: 60px;

								    .cortesia-row{
										.input-group{
											label{
												font-size: 14px;
												line-height: 17px;
											}

											input{
												font-size: 14px;
												line-height: 20px;
											}

											.small-text{
												display: none;
											}
										}

										.cortesia-ubicacion{
											.cortesia-ubicacion-item{
												padding: 4px 10px 4px 0px;

												.cortesia-ubicacion-title{
													font-size: 13px;
													line-height: 15px;
												}

												.cortesia-ubicacion-valor{
													font-size: 14px;
													line-height: 1.4em;
												}
											}
										}

										&.row-complemento{
											.input-group{
												width: 100%;
											}
										}
									}

									&:after{
										width: 40px;
										height: calc(100% - 40px);
									}

									&:before{
										width: 40px;
										height: 40px;
										font-size: 13px;
									}
							   }
						  }
						  .cortesias-canjear button.btn{
							  min-height: 40px;
							  margin-top: 20px;
							  font-size: 14px;
						  }
						  .cortesias-emitidas{
							.cortesia{
								&:after{
									background-color: var(--color-grey-light);
									color: var(--color-blue-darker);
									height: 100%;
								}

								&:before{
									content: none;
								}

								&:hover{
									&:after{
										background-color: var(--color-grey-light);
										color: var(--color-blue-darker);
									}
								}

								 .cortesia-row{
									.input-group{
										width: 80%;
										label{
											font-size: 13px;
											line-height: 16px;
										}

										span{
											font-size: 13px;
											line-height: 18px;
										}
									}

									.descargar-ticket, .generando-ticket{
										position: absolute;
										top: 20px;
										right: 20px;
										font-size: 11px;
									}

									.cortesia-ubicacion{
										.cortesia-ubicacion-item{
											padding: 3px 10px 3px 0px;

											.cortesia-ubicacion-title{
												font-size: 12px;
												line-height: 14px;
											}

											.cortesia-ubicacion-valor{
												font-size: 13px;
												line-height: 1.3em;
											}
										}
									}
								 }
							}
						  }
					 }
				}
			}
		}
	}

	@media screen and(max-width: 510px){
		.cortesia-page{
			.cortesia-main{
				.container{
					 .cortesia-left{
						  .cortesias{
							   .cortesia{
								    .cortesia-row{
										@include flex(column, flex-start, flex-start);

										.input-group{
											width: 100%;
											padding: 0px;
											padding-bottom: 5px;
										}

										.cortesia-ubicacion{
											flex-wrap: wrap;
										}
									}
							   }
						  }
					 }
				}
			}
		}
	}

	@media screen and(max-width: 490px){
		.cortesia-page{
			.cortesia-header{
				height: 250px;

				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 20px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 30px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							display: none;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 26px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}
		}
	}

	@-webkit-keyframes rotating {
		from {
			-webkit-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-webkit-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@keyframes rotating {
		from {
			-ms-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-webkit-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-ms-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-webkit-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
</style>